import axios from 'axios';
import ResponseInterceptor from './response-interceptor';

const instance = axios.create({});
instance.interceptors.response.use(ResponseInterceptor);

export default instance;
